module.exports = {
          srcSet: __webpack_public_path__ + "bfe0f10012a07ff5985d21dfc1a99e50-313.png"+" 313w",
          images:[ {path: __webpack_public_path__ + "bfe0f10012a07ff5985d21dfc1a99e50-313.png",width: 313,height: 116}],
          src: __webpack_public_path__ + "bfe0f10012a07ff5985d21dfc1a99e50-313.png",
          toString:function(){return __webpack_public_path__ + "bfe0f10012a07ff5985d21dfc1a99e50-313.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAECAYAAAC3OK7NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXElEQVR4nE3NvQqCABQF4G90cRBHKXA0cIiyEqXGFh+gwanX8OXlwh08cJbzCxvu+OOKE0a8cXbAigcWvNDggwEdnigiGOYNvzRLTLikHiPxaEabYrDOQp+BL6odl0sHzev9MOwAAAAASUVORK5CYII=",
          width: 313,
          height: 116
        }